var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<script>window.dataLayer = window.dataLayer || [];\ndataLayer.push ({'Error' : '404' });\n</script><div class=\"login error-page p404\"><div class=\"wrapper-main\"><div class=\"container\"><img" + (jade.attr("src", require('./404-error-illustration.svg'), true, true)) + " width=\"380\" alt=\"\"><h2>We can't find what you're looking for.</h2><h3>Trying to apply to a property?</h3><p>Looks like the link you’re trying to reach may be incorrect or no longer active. Please contact the landlord or property manager directly for the correct link.</p></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/home/404/404.jade
// module id = 575
// module chunks = 0